import { $logsVersion, logs } from './logbook';
import { persistentAtom } from './persistence';
import type { Operator } from '@/data/operator';
import { computed } from 'nanostores';

/**
 * Operators store - manually added operators
 */
export const $operators = persistentAtom<Operator[]>('operators', []);

/**
 * Predefined call signs (in addition to those derived from logs)
 */
export const $predefinedCallSigns = persistentAtom<string[]>(
  'predefinedCallSigns',
  [],
);

/**
 * Predefined frequencies (in addition to those derived from logs)
 */
export const $predefinedFrequencies = persistentAtom<string[]>(
  'predefinedFrequencies',
  [],
);

/**
 * Add an operator
 */
export function addOperator(operator: Operator) {
  $operators.set([...$operators.get(), operator]);
}

/**
 * Remove an operator
 */
export function removeOperator(operatorId: string) {
  $operators.set($operators.get().filter(op => op.id !== operatorId));
}

/**
 * Derived: All call signs (predefined + from logs)
 */
export const $allCallSigns = computed(
  [$predefinedCallSigns, $logsVersion],
  predefined => {
    const fromLogs = logs.getCallSigns();
    const combined = [...new Set([...predefined, ...fromLogs])];
    return combined.sort();
  },
);

/**
 * Derived: All frequencies (predefined + from logs)
 */
export const $allFrequencies = computed(
  [$predefinedFrequencies, $logsVersion],
  predefined => {
    const fromLogs = logs.getFrequencies();
    const combined = [...new Set([...predefined, ...fromLogs])];
    return combined.sort();
  },
);

/**
 * Add a predefined call sign
 */
export function addPredefinedCallSign(callSign: string) {
  const current = $predefinedCallSigns.get();
  if (!current.includes(callSign)) {
    $predefinedCallSigns.set([...current, callSign]);
  }
}

/**
 * Add a predefined frequency
 */
export function addPredefinedFrequency(frequency: string) {
  const current = $predefinedFrequencies.get();
  if (!current.includes(frequency)) {
    $predefinedFrequencies.set([...current, frequency]);
  }
}
